import { useFormik } from "formik";
import Select from "../../../components/select";
import { usePoolList, useSubnetList } from "../layout/resuableEffect";
import * as Yup from "yup";
import Input from "../../../components/input";
import arrow from "../../../assets/svg-icons/blueArrow.svg";
import { useDispatch, useSelector } from "react-redux";
import { createNetworkSubnet, listLoadBalancer, deletePool, createLoadPool, updateLoadPool } from "../../../hooks/local/userReducer";
import { useNavigate } from "react-router-dom";
import TextArea from "../../../components/textArea";
import { useState, useMemo } from "react";
import { FormatDate } from "../../../hooks/constants";
import close from "../../../assets/svg-icons/closeBrand.svg";
import Modal from "../../../components/modal";
import TabContent from "../../../components/TabContent";
import Button from "../../../components/button";
import CreatePool from "./createLoadBalancerPool";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



const LoadBalancerPools = () => {

  document.title = "Load Balancer Pools - Cloudvantage";


  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectedProject = useSelector((state) => state.user.selectedProject);
  const selectedLoadBalancer = JSON.parse(sessionStorage.getItem("selectedLoadBalancer"));
  const selectedListener = JSON.parse(sessionStorage.getItem("selectedListener"));

  
  const [searchText, setSearchText] = useState("");
  const [managePoolModal, setManagePoolModal] = useState(false);
  const [createPoolModal, setCreatePoolModal] = useState(false); 
  const [editPoolModal, setEditPoolModal] = useState(false);
  const [deletePoolModal, setDeletePoolModal] = useState(false);
  const [poolDetailsModal, setPoolDetailsModal] = useState(false); 
  const [selectedPool, setSelectedPool] = useState(null);

  const projectId = selectedProject?.id;


  const toggleCreatePoolModal = () => {
    setCreatePoolModal(!createPoolModal);
  }

    


  const createPoolForm = useFormik({
    initialValues: {
      loadbalancer_id: '',
      name: '',
      protocol: '',
      lb_algorithm: '',
      alpn_protocols: [],
    },
    validationSchema: Yup.object({
      name: Yup.string().required('Pool name is required'),
      protocol: Yup.string().required('Protocol is required'),
      lb_algorithm: Yup.string().required('Algorithm is required'),
      alpn_protocols: Yup.array()
      .of(Yup.string().oneOf(['http/1.0', 'http/1.1', 'h2'], 'Invalid ALPN protocol'))
      .optional(),   
    }),
    onSubmit: async (values, { resetForm }) => {

      const loadBalancerId = selectedLoadBalancer?.loadBalancerId;

      const createPoolFormData = {
        loadbalancer_id: loadBalancerId,
        projectId,
        name: values?.name,
        protocol: values?.protocol,
        lb_algorithm: values?.lb_algorithm,
        alpn_protocols: values.alpn_protocols,
      };

      const { payload } = await dispatch(createLoadPool(createPoolFormData));
      if (payload.statuscode === '00') {
          await dispatch(listLoadBalancer({ projectId, loadBalancerId }));
          window.location.reload();
      }
    },
  });


    const poolInputs = [
      {
        type: 'text',
        element: 'input',
        name: 'name',
        label: 'Name *',
        placeholder: 'Enter pool name',
        value: createPoolForm.values.name,
        colSpan: 1,
        onChange: createPoolForm.handleChange,
        onBlur: createPoolForm.handleBlur,
        onError:
          createPoolForm?.name && createPoolForm.errors?.name
            ? createPoolForm?.errors?.name
            : null,
      },
      {
        type: 'text',
        element: 'select',
        name: 'protocol',
        label: 'Protocol *',
        placeholder: 'Select protocol',
        options: [
          { label: 'Select protocol', value: '' },
          { label: 'HTTP', value: 'HTTP' },
          { label: 'HTTPS', value: 'HTTPS' },
          { label: 'PROXY', value: 'PROXY' },
          { label: 'PROXYV2', value: 'PROXYV2' },
          { label: 'SCTP', value: 'SCTP' },
          { label: 'TCP', value: 'TCP' },
          { label: 'UDP', value: 'UDP' },
        ],
        value: createPoolForm.values.protocol,
        colSpan: 1,
        onChange: createPoolForm.handleChange,
        onBlur: createPoolForm.handleBlur,
        onError:
          createPoolForm.touched?.protocol &&
          createPoolForm.errors?.protocol
            ? createPoolForm.errors.protocol
            : null,
      },
      {
        type: 'text',
        element: 'select',
        name: 'lb_algorithm',
        label: 'Algorithm *',
        placeholder: 'Select algorithm',
        options: [
          { label: 'Select algorithm', value: '' },
          { label: 'LEAST CONNECTIONS', value: 'LEAST_CONNECTIONS' },
          { label: 'ROUND ROBIN', value: 'ROUND_ROBIN' },
          { label: 'SOURCE IP', value: 'SOURCE_IP' },
          { label: 'SOURCE IP PORT', value: 'SOURCE_IP_PORT' },
        ],
        value: createPoolForm.values.lb_algorithm,
        colSpan: 1,
        onChange: createPoolForm.handleChange,
        onBlur: createPoolForm.handleBlur,
        onError:
          createPoolForm.touched?.lb_algorithm &&
          createPoolForm.errors?.lb_algorithm
            ? createPoolForm.errors.lb_algorithm
            : null,
      },

      {
        type: 'checkbox',
        element: 'checkbox',
        name: 'alpn_protocols',
        label: 'ALPN Protocols',
        options: [
          { label: 'HTTP/1.0', value: 'http/1.0' },
          { label: 'HTTP/1.1', value: 'http/1.1' },
          { label: 'HTTP/2', value: 'h2' },
        ],
        value: createPoolForm.values.alpn_protocols,
        colSpan: 2,
        onChange: (e) => {
          const value = e.target.value;
          const currentValues = createPoolForm.values.alpn_protocols || [];
          const newValues = e.target.checked
            ? [...currentValues, value]
            : currentValues.filter((v) => v !== value);
          createPoolForm.setFieldValue('alpn_protocols', newValues);
        },
        onBlur: createPoolForm.handleBlur,
        onError:
          createPoolForm.touched.alpn_protocols &&
          createPoolForm.errors.alpn_protocols
            ? createPoolForm.errors.alpn_protocols
            : null,
      },
  ];


const editPoolForm = useFormik({
  initialValues: {
    createPool: 'yes',
    name: selectedPool?.name || '',
    protocol: selectedPool?.protocol || '',
    session_persistence: {
      type: selectedPool?.sessionPersistence?.type || '',
      cookie_name: selectedPool?.sessionPersistence?.cookie_name || '',
      persistence_timeout: selectedPool?.sessionPersistence?.persistence_timeout || '',
      persistence_granularity: selectedPool?.sessionPersistence?.persistence_granularity || '',
    },
    lb_algorithm: selectedPool?.lb_algorithm || '',
    alpn_protocols: selectedPool?.alpn_protocols || ['http/1.0', 'http/1.1', 'h2'],
  },
  enableReinitialize: true,
  validationSchema: Yup.object({
    createPool: Yup.string().required('Please select whether to update a pool'),
    name: Yup.string().when('createPool', {
      is: 'yes',
      then: (schema) => schema.required('Pool name is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
    protocol: Yup.string().when('createPool', {
      is: 'yes',
      then: (schema) => schema.required('Protocol is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
    session_persistence: Yup.object().when('createPool', {
      is: 'yes',
      then: (schema) =>
        schema.shape({
          type: Yup.string().required('Session Persistence is required'),
          cookie_name: Yup.string().when('type', {
            is: (value) => ['APP_COOKIE', 'HTTP_COOKIE'].includes(value),
            then: (schema) => schema.required('Cookie name is required for APP_COOKIE or HTTP_COOKIE'),
            otherwise: (schema) => schema.notRequired(),
          }),
          persistence_timeout: Yup.number().notRequired(),
          persistence_granularity: Yup.string().notRequired(),
        }),
      otherwise: (schema) => schema.notRequired(),
    }),
    lb_algorithm: Yup.string().when('createPool', {
      is: 'yes',
      then: (schema) => schema.required('Algorithm is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
    // alpn_protocols: Yup.array()
    //   .of(Yup.string().oneOf(['http/1.0', 'http/1.1', 'h2'], 'Invalid ALPN protocol'))
    //   .optional(),
  }),
  onSubmit: async (values, { resetForm }) => {
    try {
      await editPoolForm.validateForm();
      if (Object.keys(editPoolForm.errors).length > 0) {
        Object.entries(editPoolForm.errors).forEach(([field, message]) => {
          if (field === 'session_persistence') {
            Object.entries(editPoolForm.errors.session_persistence).forEach(([subField, subMessage]) => {
              toast.error(`Session Persistence ${subField}: ${subMessage}`);
            });
          } else {
            toast.error(`${field}: ${message}`);
          }
        });
        return;
      }

      if (values.createPool === 'no') {
        setEditPoolModal(false);
        return;
      }

      const loadBalancerId = selectedLoadBalancer.loadBalancerId;

      const editPoolFormData = {
        loadbalancer_id: loadBalancerId,
        poolId: selectedPool?.id,
        projectId,
        name: values.name,
        protocol: values.protocol,
        lb_algorithm: values.lb_algorithm,
        session_persistence:
          values.session_persistence.type && values.session_persistence.type !== 'none'
            ? {
                type: values.session_persistence.type,
                cookie_name: values.session_persistence.cookie_name || undefined,
                persistence_timeout: values.session_persistence.persistence_timeout || undefined,
                persistence_granularity: values.session_persistence.persistence_granularity || undefined,
              }
            : undefined,
        alpn_protocols: values.alpn_protocols,
      };

      const { payload } = await dispatch(updateLoadPool(editPoolFormData));
      if (payload.statuscode === '00') {
        await dispatch(listLoadBalancer({ projectId, loadBalancerId }));
        resetForm();
        setEditPoolModal(false);
        window.location.reload();
      }
    } catch (error) {
      toast.error('An unexpected error occurred during submission.');
      console.error(error);
    }
  },
});

// Update editPoolInputs
const editPoolInputs = useMemo(() => [
  // {
  //   type: 'choice',
  //   element: 'choice',
  //   name: 'createPool',
  //   label: 'Update Pool? *',
  //   choices: [
  //     { label: 'Yes', value: 'yes' },
  //     { label: 'No', value: 'no' },
  //   ],
  //   value: editPoolForm.values.createPool,
  //   colSpan: 2,
  //   onChange: (value) => editPoolForm.setFieldValue('createPool', value),
  //   onBlur: editPoolForm.handleBlur,
  //   onError:
  //     editPoolForm.touched.createPool && editPoolForm.errors.createPool
  //       ? editPoolForm.errors.createPool
  //       : null,
  // },
  ...(editPoolForm.values.createPool === 'yes' ? [
    {
      type: 'text',
      element: 'input',
      name: 'name',
      label: 'Name *',
      placeholder: 'Enter pool name',
      value: editPoolForm.values.name,
      colSpan: 1,
      onChange: editPoolForm.handleChange,
      onBlur: editPoolForm.handleBlur,
      onError:
        editPoolForm.touched.name && editPoolForm.errors.name
          ? editPoolForm.errors.name
          : null,
    },
    {
      type: 'text',
      element: 'select',
      name: 'protocol',
      label: 'Protocol *',
      placeholder: 'Select protocol',
      options: [
        { label: 'Select protocol', value: '' },
        { label: 'HTTP', value: 'HTTP' },
        { label: 'HTTPS', value: 'HTTPS' },
        { label: 'PROXY', value: 'PROXY' },
        { label: 'PROXYV2', value: 'PROXYV2' },
        { label: 'SCTP', value: 'SCTP' },
        { label: 'TCP', value: 'TCP' },
        { label: 'UDP', value: 'UDP' },
      ],
      value: editPoolForm.values.protocol,
      disabled: true,
      colSpan: 1,
      onChange: editPoolForm.handleChange,
      onBlur: editPoolForm.handleBlur,
      onError:
        editPoolForm.touched.protocol && editPoolForm.errors.protocol
          ? editPoolForm.errors.protocol
          : null,
    },
    {
      type: 'text',
      element: 'select',
      name: 'session_persistence.type',
      label: 'Session Persistence *',
      placeholder: 'Select session persistence',
      options: [
        { label: 'Select session persistence', value: '' },
        { label: 'None', value: 'none' },
        { label: 'SOURCE IP', value: 'SOURCE_IP' },
        { label: 'HTTP_COOKIE', value: 'HTTP_COOKIE' },
        { label: 'APP_COOKIE', value: 'APP_COOKIE' },
      ],
      value: editPoolForm.values.session_persistence.type,
      colSpan: 1,
      onChange: editPoolForm.handleChange,
      onBlur: editPoolForm.handleBlur,
      onError:
        editPoolForm.touched.session_persistence?.type &&
        editPoolForm.errors.session_persistence?.type
          ? editPoolForm.errors.session_persistence.type
          : null,
    },
    ...(editPoolForm.values.session_persistence.type === 'APP_COOKIE' ||
    editPoolForm.values.session_persistence.type === 'HTTP_COOKIE'
      ? [
          {
            type: 'text',
            element: 'input',
            name: 'session_persistence.cookie_name',
            label: 'Cookie Name *',
            placeholder: 'Enter cookie name',
            value: editPoolForm.values.session_persistence.cookie_name,
            colSpan: 1,
            onChange: editPoolForm.handleChange,
            onBlur: editPoolForm.handleBlur,
            onError:
              editPoolForm.touched.session_persistence?.cookie_name &&
              editPoolForm.errors.session_persistence?.cookie_name
                ? editPoolForm.errors.session_persistence.cookie_name
                : null,
          },
        ]
      : []),
    {
      type: 'number',
      element: 'input',
      name: 'session_persistence.persistence_timeout',
      label: 'Persistence Timeout',
      placeholder: 'Enter persistence timeout (optional)',
      value: editPoolForm.values.session_persistence.persistence_timeout,
      colSpan: 1,
      onChange: editPoolForm.handleChange,
      onBlur: editPoolForm.handleBlur,
      onError:
        editPoolForm.touched.session_persistence?.persistence_timeout &&
        editPoolForm.errors.session_persistence?.persistence_timeout
          ? editPoolForm.errors.session_persistence.persistence_timeout
          : null,
    },
    {
      type: 'text',
      element: 'input',
      name: 'session_persistence.persistence_granularity',
      label: 'Persistence Granularity',
      placeholder: 'Enter persistence granularity (optional)',
      value: editPoolForm.values.session_persistence.persistence_granularity,
      colSpan: 1,
      onChange: editPoolForm.handleChange,
      onBlur: editPoolForm.handleBlur,
      onError:
        editPoolForm.touched.session_persistence?.persistence_granularity &&
        editPoolForm.errors.session_persistence?.persistence_granularity
          ? editPoolForm.errors.session_persistence.persistence_granularity
          : null,
    },
    {
      type: 'text',
      element: 'select',
      name: 'lb_algorithm',
      label: 'Algorithm *',
      placeholder: 'Select algorithm',
      options: [
        { label: 'Select algorithm', value: '' },
        { label: 'LEAST CONNECTIONS', value: 'LEAST_CONNECTIONS' },
        { label: 'ROUND ROBIN', value: 'ROUND_ROBIN' },
        { label: 'SOURCE IP', value: 'SOURCE_IP' },
      ],
      value: editPoolForm.values.lb_algorithm,
      colSpan: 1,
      onChange: editPoolForm.handleChange,
      onBlur: editPoolForm.handleBlur,
      onError:
        editPoolForm.touched.lb_algorithm && editPoolForm.errors.lb_algorithm
          ? editPoolForm.errors.lb_algorithm
          : null,
    },
    // {
    //   type: 'checkbox',
    //   element: 'checkbox',
    //   name: 'alpn_protocols',
    //   label: 'ALPN Protocols',
    //   options: [
    //     { label: 'HTTP/1.0', value: 'http/1.0' },
    //     { label: 'HTTP/1.1', value: 'http/1.1' },
    //     { label: 'HTTP/2', value: 'h2' },
    //   ],
    //   value: editPoolForm.values.alpn_protocols,
    //   colSpan: 2,
    //   onChange: (e) => {
    //     const value = e.target.value;
    //     const currentValues = editPoolForm.values.alpn_protocols || [];
    //     const newValues = e.target.checked
    //       ? [...currentValues, value]
    //       : currentValues.filter((v) => v !== value);
    //     editPoolForm.setFieldValue('alpn_protocols', newValues);
    //   },
    //   onBlur: editPoolForm.handleBlur,
    //   onError:
    //     editPoolForm.touched.alpn_protocols && editPoolForm.errors.alpn_protocols
    //       ? editPoolForm.errors.alpn_protocols
    //       : null,
    // },
  ] : []),
], [editPoolForm.values.createPool, editPoolForm.values, editPoolForm.touched, editPoolForm.errors, editPoolForm.handleChange, editPoolForm.handleBlur, editPoolForm.setFieldValue]);






    // {
    //     "id": "2a7aa5da-9707-4f01-96ec-7f072c323e57",
    //     "name": "https_pool",
    //     "description": "",
    //     "provisioning_status": "ACTIVE",
    //     "operating_status": "ONLINE",
    //     "admin_state_up": true,
    //     "protocol": "HTTPS",
    //     "lb_algorithm": "ROUND_ROBIN",
    //     "session_persistence": null,
    //     "project_id": "e10a5e32fa534c50b139523f4d5ddd32",
    //     "loadbalancers": [
    //         {
    //             "id": "3c69d900-f470-44a4-8284-41c85eeca5af"
    //         }
    //     ],
    //     "listeners": [
    //         {
    //             "id": "0e206830-0381-42ab-a918-220fd568f66e"
    //         }
    //     ],
    //     "created_at": "2025-04-23T14:33:59",
    //     "updated_at": "2025-06-03T08:59:54",
    //     "healthmonitor_id": "4e43e18c-0a19-46b2-96f7-63719c39021c",
    //     "members": [],
    //     "tags": [],
    //     "tls_container_ref": null,
    //     "ca_tls_container_ref": null,
    //     "crl_container_ref": null,
    //     "tls_enabled": false,
    //     "tls_ciphers": null,
    //     "tls_versions": null,
    //     "alpn_protocols": [
    //         "http/1.1",
    //         "http/1.0",
    //         "h2"
    //     ],
    //     "tenant_id": "e10a5e32fa534c50b139523f4d5ddd32"
    // }

  const poolOverviewDetails = selectedPool
  ? [
      {
        title: "Name",
        value: selectedPool?.name || "N/A",
      },
      {
        title: "Listener ID",
        value: selectedPool?.id || "N/A",
      },
      {
        title: "Project ID",
        value: selectedPool?.project_id || "N/A",
      },
      {
        title: "Connection Limit",
        value: selectedPool?.connection_limit === -1  ? "Limited" : "Unlimited" || "N/A",
      },
      {
        title: 'Session Persistence',
        value:
          Object.keys(selectedPool?.session_persistence || {}).length > 0
            ? JSON.stringify(selectedPool.session_persistence)
            : 'None',
      },
      {
        title: "Health Monitor ID",
        value: selectedPool?.healthmonitor_id || "N/A",
      },
      {
        title: "TLS Enabled",
        value: selectedPool?.tls_enabled ? "Yes" : "No" || "N/A",
      },
      {
        title: "TLS Cipher String",
        value: selectedPool?.tls_ciphers || "N/A",
      },
    ]
  : [];

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
    setCurrentPage(1);
  };

  const options = [
    { value: "all-pools", label: "All pools" },
    { value: "name", label: "Pool Name" },
  ];

  
  
  const showManagePollModal = (key, data) => {
    
      setManagePoolModal(key);
      const poolDetails = { poolId: data.id, poolName: data.name };
      sessionStorage.setItem("selectedPool", JSON.stringify(poolDetails));
  };
    
   const closeManagePoolModal = () => {
      setManagePoolModal(false);
   };
  
    const toggleListenerModal = () => {
        setSelectedPool(!selectedPool);
    };
  
    const toggleEditPoolModal = (listener) => {
      setSelectedPool(listener);
      setEditPoolModal(!editPoolModal);
    };


    const showPoolDetailsModal = (pool) => {
        
        const listenerDetails = { poolId: pool.id, poolName: pool.name };
        sessionStorage.setItem("selectedPool", JSON.stringify(listenerDetails));

        navigate("/manageLoadBalancers/pool-details");
          
    };


    const closeSubnetDetailsModal = () => {
        setPoolDetailsModal(false);
        setSelectedPool(null);
    };


    const params = `?load_balancer_id=${selectedLoadBalancer?.loadBalancerId}`
    const poolList = usePoolList(projectId, params);

    


    const poolListMap = Array.isArray(poolList)
        ? poolList.map((pool) => ({
            id: pool.id,
            name: pool.name && pool.name.trim() !== "" ? pool.name : "Default Pool",
            protocol: pool?.protocol || "N/A",
            port: pool?.protocol_port || "N/A",
            pool: pool?.default_pool_id || "N/A",
            algorithm: pool?.lb_algorithm|| "N/A",
            operatingStatus: pool?.operating_status || "N/A",
            provisioningStatus: pool?.provisioning_status || "N/A",
            sessionPersistence: pool?.session_persistence,
            adminState: pool?.admin_state_up ? "Yes" : "No",
            createdAt: FormatDate(pool.created_at),
        }))
        : [];

      const [currentPage, setCurrentPage] = useState(1);
      const entriesPerPage = 5;
    
      const filteredData = poolListMap?.filter((row) =>
        row?.name?.toLowerCase().includes(searchText.toLowerCase()) ||
        row?.algorithm?.toLowerCase().includes(searchText.toLowerCase()) ||
        row?.provisioningStatus?.toLowerCase().includes(searchText.toLowerCase()) ||
        row?.operatingStatus?.toLowerCase().includes(searchText.toLowerCase()),
      );
    
      const indexOfLastEntry = currentPage * entriesPerPage;
      const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
      const currentEntries = filteredData.slice(
        indexOfFirstEntry,
        indexOfLastEntry,
      );
      const totalPages = Math.ceil(filteredData.length / entriesPerPage);
    
      const handlePreviousPage = () => {
        if (currentPage > 1) {
          setCurrentPage(currentPage - 1);
        }
      };
    
      const handleNextPage = () => {
        if (currentPage < totalPages) {
          setCurrentPage(currentPage + 1);
        }
      };
        


      const handleServerAction = async (action, poolId) => {
        const projectId = selectedProject.id;
  
        const { payload } = await dispatch(action({ projectId, poolId }));
    
        if (payload.statuscode === "00") {
          window.location.reload();
        }
      };
    
  
    const deleteLoadPool = (poolId) =>
      handleServerAction(deletePool, poolId);



  

  return (
    <div className="min-h-screen px-4 md:px-10 pt-6 pb-10 dark:text-white">

        <div>
            {poolListMap?.length > 0 ?
            <div>
                <div className="w-full flex items-center">
                    <div className="w-full  grid grid-cols-1 md:grid-cols-12 gap-4 items-end my-10">
                        <div className="md:col-span-3">
                            <Select label="Filter pools" name="pools" options={options} />
                        </div>
                        <div className="md:col-span-4">
                        <input
                            type="search"
                            name=""
                            value={searchText}
                            onChange={handleSearchChange}
                            placeholder="Search for pool..."
                            className="bg-white text-black w-full p-4 text-sm rounded-md border border-[#c4c4c460] active:outline-0 focus:outline-0 placeholder:opacity-70 placeholder:text-xs dark:bg-slate-800 dark:text-white"
                        />
                        </div>
                    </div>
                    <div className="w-full flex items-end justify-end">

                      <button
                          className={`cursor-pointer px-4 py-3 text-xs border-[1.5px] border-primaryBlue rounded-md text-primaryBlue w-fit`}
                          onClick={toggleCreatePoolModal}
                      >
                          Create Pool
                      </button>
                    </div>

                </div>

                <div className="overflow-x-auto rounded-md border dark:border-[#c4c4c432]">
                <table className="w-full text-sm text-left overflow-hidden">
                    <thead className="bg-white dark:bg-slate-800 px-3 md:px-4 border text-gray-400 dark:border-[#c4c4c432] border-b text-sm font-semibold">
                    <tr>
                        <th scope="col" className="px-6 py-4 whitespace-nowrap w-5">
                            #
                        </th>
                        <th scope="col" className="px-6 py-4 whitespace-nowrap max-w-52">
                            Pool name
                        </th>
                        <th scope="col" className="px-6 py-4 whitespace-nowrap">
                            Protocol
                        </th>
                        <th scope="col" className="px-6 py-4 whitespace-nowrap">
                            Algorithm
                        </th>
                        <th scope="col" className="px-6 py-4 whitespace-nowrap">
                            Operating Status
                        </th>
                        <th scope="col" className="px-6 py-4 whitespace-nowrap">
                            Provisioning Status
                        </th>
                        <th scope="col" className="px-6 py-4 whitespace-nowrap">
                            Actions
                        </th>
                    </tr>
                    </thead>
                    <tbody className="bg-white dark:bg-slate-800 px-3 md:px-4 border rounded-b-md dark:border-[#c4c4c432] border-t-2 text-sm">
                    {currentEntries.map((row, index) => (
                        <tr
                          key={index}
                          className="dark:hover:bg-[#ffffff05] hover:bg-brandBlue/25 whitespace-nowrap"
                        >
                        <td className="text-start py-4 px-6">{index + 1}.</td>
                        <td
                          className="text-start py-4 px-6 text-primaryBlue hover:underline cursor-pointer"
                          onClick={() => showPoolDetailsModal(poolList.find((s) => s.id === row.id))}
                        >
                          {row.name}
                        </td>
                        <td className="text-start py-4 px-6">{row.protocol}</td>
                        <td className="text-start py-4 px-6">{row.algorithm}</td>
                        <td className="text-start py-4 px-6">{row.operatingStatus}</td>
                        <td className="text-start py-4 px-6">{row.provisioningStatus}</td>
                        <td className="text-start py-4 px-6">
                            <button
                                className="text-white p-3 text-xs rounded bg-primaryBlue w-full md:w-fit"
                                onClick={() => showManagePollModal(index, row)}
                            >
                                Manage Pool
                            </button>

                            {managePoolModal === index && (
                                <div className="w-full fixed h-screen bg-black/70 top-0 left-0 px-4 flex items-end md:items-center justify-center z-50">
                                    <div className="bg-white dark:bg-[#141D26] rounded w-full md:w-[30%] dark:text-white max-h-[80%] mb-4 md:mb-0 overflow-auto">
                                    <div className="flex justify-between items-center text-sm p-6 border-b dark:border-b-[#c4c4c432]">
                                        <div className="flex gap-2 items-center">
                                            <span className="dark:text-white">
                                                Manage "{row.name}"
                                            </span>
                                            </div>
                                            <img
                                                src={close}
                                                onClick={closeManagePoolModal}
                                                className="h-5 cursor-pointer"
                                                alt=""
                                            />
                                        </div>
                                    <div className="p-4 grid gap-1">
                                        <div
                                            className="flex items-center justify-between hover:rounded mb-4 dark:border-[#c4c4c424] last:border-none py-4 px-3 hover:bg-primaryBlue/5 transition-all cursor-pointer"
                                            onClick={() => toggleEditPoolModal(row)}
                                        >
                                            <span>Edit Pool</span>
                                            <span>
                                                <img src={arrow} alt="" className="" />
                                            </span>
                                        </div>
        
                                        <div
                                            className="flex justify-self-center text-red-500 rounded-md py-5 px-3 text-center cursor-pointer"
                                            onClick={() => {
                                                setDeletePoolModal(true);
                                            }}
                                        >
                                            <span className="hover:underline">
                                                Delete Pool
                                            </span>
                                        </div>
                                    </div>
                                    <Modal
                                        title={"Delete Pool"}
                                        isVisible={deletePoolModal}
                                        onClose={() => setDeletePoolModal(false)}
                                    >
                                        <div className="text-sm text-center pt-6 text-wrap">
                                            Are you sure you want to delete{" "}
                                            <span className="underline">{row.name}</span> .
                                            This action cannot be undone.
                                        </div>
                                        <div className="grid gap-4 justify-center py-6">
                                            <button
                                                className="bg-red-500 text-white text-xs px-6 py-4 rounded-sm w-fit"
                                                onClick={() => deleteLoadPool(row.id)}

                                            >
                                                Yes, delete {row.name}
                                            </button>
                                            <button
                                                className="text-[#1DA1F2] text-sm px-6 py-2 hover:underline"
                                                onClick={() => setDeletePoolModal(false)}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </Modal>
            
                                  </div>
                                </div>
                            )}

                        </td>
    
                    </tr>
                    ))}
                    </tbody>
                </table>
                </div>
                <div className="grid justify-center gap-4 md:flex md:justify-between items-center mt-4">
                <p className="text-gray-400 text-sm">
                    Showing{" "}
                    <span className="font-medium text-black dark:text-white">
                        {indexOfFirstEntry + 1}
                    </span>{" "}
                        to{" "}
                    <span className="font-medium text-black dark:text-white">
                        {Math.min(indexOfLastEntry, poolListMap?.length)}
                    </span>{" "}
                        of{" "}
                    <span className="font-medium text-black dark:text-white">
                        {poolListMap?.length}
                    </span>{" "}
                    results
                </p>
                <div className=" flex gap-3">
                    <button
                        className={`bg-white dark:bg-primaryBlue border dark:border-none rounded-md py-3 px-5 text-sm ${currentPage === 1 ? "opacity-50" : "opacity-100"}`}
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    <button
                        className={`bg-white dark:bg-primaryBlue border dark:border-none rounded-md py-3 px-5 text-sm ${currentPage === totalPages ? "opacity-50" : "opacity-100"}`}
                        onClick={handleNextPage}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
                </div>
            </div>
    
            :
    
            <>
                <div className="md:px-52 text-center grid text-gray-500 mt-32">
                    <div>It looks like you don't have pools attached to this load balancer yet. Once you create a pool, your pools will appear here.</div>
                    <div className="w-full flex flex-col items-center justify-center mt-4">
                        <button
                            className={`cursor-pointer px-4 py-3 text-xs border-[1.5px] border-primaryBlue rounded-md text-primaryBlue w-fit`}
                            onClick={toggleCreatePoolModal}
                        >
                            Create Pool
                        </button>
                    </div>
                </div>
            
            </> 
            
            }
            
        </div>
      

        {poolDetailsModal && selectedPool && (
            <div className="fixed w-full bg-black/60 top-0 left-0 z-50 h-screen">
            <div className="w-full flex h-full items-center justify-center p-4">
                <div className="bg-white dark:bg-[#141D26] dark:text-white w-full md:w-[80%] rounded h-full overflow-y-auto">
                <div className="px-6 md:px-10 py-6 border-b dark:border-b-[#c4c4c432] flex justify-between items-center">
                    <span className="text-primaryBlue font-medium">Pool Information:</span>
                    <span onClick={closeSubnetDetailsModal} className="cursor-pointer">
                    <img src={close} alt="Close" className="h-5" />
                    </span>
                </div>

                <div className="py-10 grid gap-6 px-6">
                    <div className="w-full flex flex-col items-start gap-4">
                    <h4 className="w-full text-black dark:text-white text-lg mb-4 border-b border-gray-400 pb-2">
                        Pool Details:
                    </h4>

                    <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6">
                        {poolOverviewDetails.map((detail, index) => (
                        <div key={index} className="w-full flex flex-col items-start">
                            <h4 className="text-black dark:text-white text-lg">{detail.title}:</h4>
                            <h4 className="text-gray-800 dark:text-gray-200 font-semibold text-xl">
                                {detail.value}
                            </h4>
                        </div>
                        ))}
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        )}


        {createPoolModal && (
          <CreatePool
            isVisible={createPoolModal}
            onClose={toggleCreatePoolModal}
            loadBalancerId={selectedLoadBalancer?.loadBalancerId}
          />
        )}


      {editPoolModal && (
        <div className="fixed top-0 h-screen w-full left-0 z-50 flex items-center justify-center p-4 bg-[rgba(0,0,0,0.5)]">
          <div className="bg-white dark:bg-[#141D26] rounded-md p-4 md:p-10 w-full md:w-[80%] max-h-[95%] overflow-y-scroll shadow-xl shadow-[rgba(0,0,0,0.5)]">
            <div className="flex items-center justify-between mb-4">
              <p className="text-primaryBlue">Update Pool for {selectedPool?.name}</p>
              <span onClick={() => setEditPoolModal(false)} className="cursor-pointer">
                <img alt="Close" src={close} className="h-5" />
              </span>
            </div>
            <div className="w-full flex flex-col justify-start items-start gap-2 py-4 px-4">
              <form onSubmit={editPoolForm.handleSubmit} className="w-full">
                <TabContent
                  title="Provide the details for the pool"
                  inputs={editPoolInputs}
                />
                <div className="w-full flex justify-end items-center gap-2 mt-4">
                  <button
                    type="button"
                    className="px-4 py-4 text-xs border border-primaryBlue rounded-sm text-primaryBlue cursor-pointer text-center"
                    onClick={() => setEditPoolModal(false)}
                  >
                    Cancel
                  </button>
                  <Button
                    buttonText="Update Pool"
                    buttonRole="submit"
                    type="submit"
                    handleClick={editPoolForm.handleSubmit}
                  />
                </div>
              </form>
            </div>
            <ToastContainer />
          </div>
        </div>
      )}



    </div>
  );
};

export default LoadBalancerPools;
